import { render, staticRenderFns } from "./SchoolListTotalItem.vue?vue&type=template&id=50eadb8c&scoped=true&lang=pug&"
import script from "./SchoolListTotalItem.vue?vue&type=script&lang=js&"
export * from "./SchoolListTotalItem.vue?vue&type=script&lang=js&"
import style0 from "./SchoolListTotalItem.vue?vue&type=style&index=0&id=50eadb8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eadb8c",
  null
  
)

export default component.exports